import React from 'react';
import {Box, Container} from '@mui/material';

function ProjectTextBox({children, withBackground}) {
    return (
        <Box sx={{
            backgroundColor: withBackground ? '#f5f5f5' : 'transparent',
            width: '100%',
            py: {xs: '32px', md: '48px'},
        }}>
            <Container sx={{maxWidth: 'md'}}>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: '16px'}}>
                    {children}
                </Box>
            </Container>
        </Box>
    );
}

export default ProjectTextBox;
